// 年假计算函数
// dateString 入职时间 格式 xxxx-xx-xx
const annualLeave = (dateString) => {
  let date = fomat(dateString);
  let currentDate = new Date();
  const diff = isTimeDifferenceGreaterThanOneYear(date, currentDate)
  if (!diff) {
    return 0
  }
  const yearDiff = Math.abs(date.getFullYear() - currentDate.getFullYear());
  if (yearDiff == 1) {
    const lastDay = new Date(currentDate.getFullYear(), 11, 31);
    const year = date.getFullYear() + 1
    date.setFullYear(year)
    const d = getDaysDifference(date, lastDay)
    return Math.round((d / 365) * 5)
  }
  if (yearDiff >= 10 && yearDiff < 20) {
    return 10
  }
  if (yearDiff >= 20) {
    return 15
  }
  return 5
}

const fomat = (dateString) => {
  const dateParts = dateString.split("-");
  const year = parseInt(dateParts[0]);
  const month = parseInt(dateParts[1]) - 1;
  const day = parseInt(dateParts[2]);
  return new Date(year, month, day);
}

const isTimeDifferenceGreaterThanOneYear = (start, end) => {
  const oneYearLater = new Date(start.getTime());
  // 设置end日期在一年之后
  oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
  // 结束日期大于等于计算日期,说明超过一年
  return end.getTime() >= oneYearLater.getTime();

  // 如果 end 日期在 start 日期加一整年之后
  // return isBefore(add(start, { years: 1 }), end);
  // const yearDiff = Math.abs(start.getFullYear() - end.getFullYear());
  // if (yearDiff > 1) {
  //   return true;
  // }
  // if (yearDiff === 1) {
  //   if (start.getMonth() === end.getMonth()) {
  //     if (start.getDate() === end.getDate()) {
  //       return false;
  //     }
  //   }
  //   return true;
  // }
  // return false;
}

const getDaysDifference = (start, end) => {
  const startTime = start.getTime();
  const endTime = end.getTime();
  const timeDifference = endTime - startTime;
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  return daysDifference;
}

export { annualLeave };
